import api from "apis/customerConfigurationAppraisal";
import { HTTP_GET, HTTP_POST, HTTP_DELETE, WebApiReduxRequest } from "tools/webservice";
import { CALL_API } from "redux-api-middleware";
import responseHandler from "responseHandler";
import {
  REQUEST_APPRAISER_ORDER_REQUIREMENTS,
  RECEIVE_APPRAISER_ORDER_REQUIREMENTS,
  ERROR_APPRAISER_ORDER_REQUIREMENTS,
  REQUEST_UPLOAD_APPRAISER_ORDER_REQUIREMENTS,
  RECEIVE_UPLOAD_APPRAISER_ORDER_REQUIREMENTS,
  ERROR_UPLOAD_APPRAISER_ORDER_REQUIREMENTS,
  REQUEST_DELETE_APPRAISER_ORDER_REQUIREMENTS,
  RECEIVE_DELETE_APPRAISER_ORDER_REQUIREMENTS,
  ERROR_DELETE_APPRAISER_ORDER_REQUIREMENTS,
} from "typeConstants";

const getAppraiserOrderRequirements = (customerNumber, surveyTypeCode) => WebApiReduxRequest(
  REQUEST_APPRAISER_ORDER_REQUIREMENTS,
  RECEIVE_APPRAISER_ORDER_REQUIREMENTS,
  ERROR_APPRAISER_ORDER_REQUIREMENTS,
  HTTP_GET,
  api.appraiserOrderRequirements(customerNumber, surveyTypeCode)
);

const uploadAppraiserOrderRequirements = (customerNumber, surveyTypeCode, payload) => {
  const data = new FormData();
  data.append("file", payload);

  return dispatch => (
    dispatch({
      [CALL_API]: {
        endpoint: api.appraiserOrderRequirements(customerNumber, surveyTypeCode),
        method: HTTP_POST,
        body: data,
        requestType: "upload", // This will get picked up in the middlewares/genericHeaders/index.js and it will delete our Content-Type that it usually sets so the browser can generate a proper Content-Type
        types: [
          REQUEST_UPLOAD_APPRAISER_ORDER_REQUIREMENTS,
          {
            type: RECEIVE_UPLOAD_APPRAISER_ORDER_REQUIREMENTS,
            payload: (action, state, res) =>
              res.json()
                .then(data => {
                  setTimeout(() => {
                    if (data.error) {
                      responseHandler.clientErrors(data.errorMessages, dispatch);
                    }
                  }, 0);
                  return data;
                })
          },
          {
            type: ERROR_UPLOAD_APPRAISER_ORDER_REQUIREMENTS,
            payload: (action, state, res) => {
              responseHandler.error(res, dispatch);
              return;
            }
          }
        ]
      }
    })
  );
};

const deleteAppraiserOrderRequirements = (customerNumber, surveyTypeCode) => WebApiReduxRequest(
  REQUEST_DELETE_APPRAISER_ORDER_REQUIREMENTS,
  RECEIVE_DELETE_APPRAISER_ORDER_REQUIREMENTS,
  ERROR_DELETE_APPRAISER_ORDER_REQUIREMENTS,
  HTTP_DELETE,
  api.appraiserOrderRequirements(customerNumber, surveyTypeCode)
);

export {
  getAppraiserOrderRequirements,
  uploadAppraiserOrderRequirements,
  deleteAppraiserOrderRequirements,
};
